var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { fields } from './fieldHelpers.js';
import cuid from 'cuid';
export function collection(_a) {
    var { synthetics, indexes } = _a, input = __rest(_a, ["synthetics", "indexes"]);
    // back compat - copy synthetics in with indexes
    const finalIndexes = Object.assign(Object.assign({}, synthetics), indexes);
    // add all indexed fields into the synthetic indices (back compat)
    for (const [key, field] of Object.entries(input.fields)) {
        if ('indexed' in field) {
            finalIndexes[key] = {
                field: key,
            };
        }
    }
    return Object.assign(Object.assign({}, input), { indexes: finalIndexes });
}
export function schema(input) {
    return input;
}
schema.collection = collection;
schema.fields = fields;
schema.generated = {
    id: cuid,
};
export * from './types.js';
export * from './indexFilters.js';
export * from './fields.js';
export * from './validation.js';
export * from './children.js';
//# sourceMappingURL=index.js.map